module.exports = __webpack_public_path__ + "static/media/s_icon_04.41fb8c7c.png";